import React, { useContext } from "react";
import { Checkbox } from "@fluentui/react-components";
import styled from "styled-components";
import { Column, TaxonomyFilter as TaxonomyFilterType } from "./types";
import { Truncate } from "components/styled";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = {
  column: Column;
};

export const TaxonomyFilter = ({ column }: Props) => {
  const filter = column.filter as TaxonomyFilterType;
  const selectedValues = filter.value;

  const renderLabel = filter.renderLabel;
  const { taxonomy, setFilter, t, id } = useContext(ColumnOptionsContext);
  const maxSelectionReached =
    !!filter.maxOptionsSelect &&
    selectedValues.length >= filter.maxOptionsSelect;

  const options = (taxonomy[filter.taxonomyKey] || []).filter((tax) => {
    if (filter.exclude) {
      return !filter.exclude.includes(tax.code);
    }
    return true;
  });

  return (
    <div>
      {options.map((tax) => {
        const isChecked = selectedValues.includes(tax.id);
        return (
          <CheckboxRow key={tax.id}>
            <Checkbox
              checked={isChecked}
              style={{ marginRight: 2 }}
              disabled={maxSelectionReached && !isChecked}
              id={
                id
                  ? `${id}-taxonomyFilter-${column.key}-${tax.code}`
                  : undefined
              }
              onChange={(_, data) => {
                let value;
                if (data.checked) {
                  if (maxSelectionReached && !isChecked) return;
                  value = selectedValues.concat([tax.id]);
                } else {
                  value = selectedValues.filter((id) => id !== tax.id);
                }

                setFilter(column.key, {
                  ...filter,
                  value,
                });
              }}
            />
            {renderLabel ? (
              renderLabel({ taxonomy: tax, t })
            ) : (
              <Truncate>{t(tax.code)}</Truncate>
            )}
          </CheckboxRow>
        );
      })}
    </div>
  );
};

const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
`;
